import React from "react";
import { Row, Col } from "antd";
import moment from "moment";
import { months, years } from "constant/commonList";
import AppButton from "components/AppButton/AppButton";
import FormSelectInput from "components/FormItems/FormSelectInput";

const MonthFilterMenu = ({
  month,
  year,
  setMonth,
  setYear,
  span = {
    xs: 24,
    sm: 12,
    md: 8,
    lg: 6,
    xl: 4
  },
  exportData = [],
  showExportButton = true
}) => {
  return (
    <Row gutter={[16, 16]} className="px-3" type="flex" justify="end" align="middle">
      {showExportButton && (
        <Col lg={span}>
          <AppButton size="default" label="Export to CSV" light onClick={() => console.log({ exportData })} />
        </Col>
      )}
      <Col lg={span}>
        <FormSelectInput
          placeholder="Select Month"
          name="month"
          size="default"
          value={month}
          onChange={val => {
            if (val > moment().month() + 1 && year == moment().format("YYYY")) {
              setYear(moment().format("YYYY") - 1);
            }
            setMonth(val);
          }}
          options={months}
        />
      </Col>
      <Col lg={span}>
        <FormSelectInput
          placeholder="Select Year"
          name="year"
          size="default"
          value={year}
          onChange={val => {
            if (val == moment().format("YYYY")) {
              setMonth(moment().month() + 1);
            }
            setYear(val);
          }}
          options={years}
        />
      </Col>
    </Row>
  );
};

export default MonthFilterMenu;
